import BliIconSiSocmedFacebook from '@blibli/blue-dls-library-icon/dist/SocmedFacebook'
import BliIconSiSocmedInstagram from '@blibli/blue-dls-library-icon/dist/SocmedInstagram'
import BliIconSiSocmedLinkedin from '@blibli/blue-dls-library-icon/dist/SocmedLinkedin'
import BliIconSiSocmedYoutube from '@blibli/blue-dls-library-icon/dist/SocmedYoutube'

import CONSTANTS from '@/constants'

export default {
  components: {
    BliIconSiSocmedFacebook,
    BliIconSiSocmedInstagram,
    BliIconSiSocmedLinkedin,
    BliIconSiSocmedYoutube
  },
  setup () {
    const socialMediaLinks = CONSTANTS.SOCIALMEDIURLS

    const redirect = (link) => {
      window.open(link, '_blank')
    }

    const sendEmail = () => {
      window.location.href = 'mailto:recruitment@blibli.com'
    }

    return {
      socialMediaLinks,
      redirect,
      sendEmail
    }
  }
}
